var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 107,
    viewBox: "0 0 117 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 107,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7992 21.3H90.2992V90.3C90.2992 94.1 87.1992 97.2 83.3992 97.2H32.5992C28.7992 97.2 25.6992 94.1 25.6992 90.3L25.7992 21.3Z",
    fill: "white",
    stroke: "#05054B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4992 29.2V16.6C67.5992 14.8 66.5992 12.3 66.5992 10.6C66.5992 8.90001 64.5992 9.00001 64.5992 9.00001H58.6992H57.7992H51.8992C51.8992 9.00001 49.8992 8.90001 49.8992 10.6C49.8992 12.3 48.8992 14.8 48.9992 16.6V29.2C48.9992 29.2 48.6992 31.8 50.9992 31.8H57.7992C58.3992 31.8 58.6992 31.8 58.6992 31.8H65.4992C67.7992 31.8 67.4992 29.2 67.4992 29.2Z",
    fill: "#9E8959",
    stroke: "#9E8959",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3008 12.5V28.1",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4004 14.4V28.1",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0996 14.4V28.1",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5 32.4V47.4",
    stroke: "#05054B",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9004 32.4V47.4",
    stroke: "#05054B",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6992 47.4V37.4H63.9992",
    stroke: "#9E8959",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9 41.5002V40.7002H59V41.5002H64.9Z",
    fill: "#33333F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9 42.3V41.9H59V42.3H64.9Z",
    fill: "#33333F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9 43.5V43.1H59V43.5H64.9Z",
    fill: "#33333F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9 45.4V45.1H59V45.4H64.9Z",
    fill: "#33333F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9 47V46.6H59V47H64.9Z",
    fill: "#33333F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3008 47.3H89.7008",
    stroke: "#05054B",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 90,
    fill: "white",
    transform: "translate(25 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step_3.95f7e1f927c69c476fc98e98a7dc2ab8.svg";
export { ForwardRef as ReactComponent };